















































































































































































































































































































































































































































import { getModule } from "vuex-module-decorators";
import { Vue, Component, Prop } from "vue-property-decorator";
import ComapanyModule from "@/store/vuex-modules/companies";
import tradeshowVuexModule from "@/store/vuex-modules/getTradeshowData";
import eventHub from "@/event-hub";
import Spinners from "@/components/utilities/Spinners.vue";
import states from "@/assets/dictionaries/state-list.ts";
import country from "@/assets/dictionaries/country-list.ts";
import cities from "@/assets/dictionaries/citiesWithState.ts";

declare module "@/assets/dictionaries/state-list.ts";
declare module "@/assets/dictionaries/country-list.ts";
declare module "@/assets/dictionaries/citiesWithState.ts";

const companyStore = getModule(ComapanyModule);
const tradeshowStore = getModule(tradeshowVuexModule);

@Component({
    components: { Spinners }
})
export default class ExhibitorProfileEditForm extends Vue {
    @Prop({ default: "" })
    id!: string;
    beLazy = true;
    value = null;
    isReady = false;

    states = states;
    countries = country;
    cities: any = cities;
    citiesToLoad = [];

    selectedState: string[] = [];

    isLoading = false;
    submitSucess = false;
    submitError = false;
    valueForReset = {};
    updatePayload: any = {
        companyDescription: "",
        featuredDescription: "",
        companyName: "",
        featuredTitle: "",
        featuredVideo: "",
        address: {
            zip: "",
            address: "",
            state: "",
            city: "",
            country: ""
        },
        social: {
            instragram: "",
            facebook: "",
            linkedIn: "",
            youtube: "",
            feedburner: "",
            twitter: ""
        },

        mainPhone: "",
        websiteURL: "",

        resources: [],
        companyVideos: [],
        companyAttendees: [],
        videos: [],

        testimonials: [
            {
                image: "",
                description: "",
                name: "",
                company: "",
                title: ""
            }
        ]
    };

    //getters

    get stateName() {
        const stateAbbr = "alpha-2";
        return Object(this.states).map((item: any) => item[`${stateAbbr}`]);
    }

    get loadCities() {
        const cities = Object.keys(this.cities)
            .filter(key => this.selectedState.includes(key))
            .reduce((obj: any, key: string) => {
                obj[key] = this.cities[key];
                return obj;
            }, {});

        return cities;
    }

    //life cyscles
    updated() {
        this.selectedState.push(this.updatePayload.address.state);
        this.selectedState.pop;
    }

    created() {
        this.initData();

        eventHub.$on("company-update-started", this.handleUpdateStarted);
        eventHub.$on("company-update-success", this.handleUpdateSuccess);
        eventHub.$on("company-update-error", this.handleUpdateError);
        eventHub.$on("company-update-done", this.handleUpdateDone);
    }

    beforeDestroy() {
        this.resetSubmitFlags();
        this.setUpdatePayload();

        eventHub.$off("company-update-started", this.handleUpdateStarted);
        eventHub.$off("company-update-success", this.handleUpdateSuccess);
        eventHub.$off("company-update-error", this.handleUpdateError);
        eventHub.$off("company-update-done", this.handleUpdateDone);
    }

    //methods

    initData() {
        const companyData = JSON.parse(
            JSON.stringify(companyStore.companyData)
        );

        const {
            companyDescription,
            featuredDescription,
            companyName,
            featuredTitle,
            featuredVideo,
            address,
            social,
            mainPhone,
            websiteURL,
            resources,
            testimonials
        } = companyData;

        const dataForReset = {
            companyDescription,
            featuredDescription,
            companyName,
            featuredTitle,
            featuredVideo,
            address,
            social,
            mainPhone,
            websiteURL,
            resources,
            testimonials
        };

        let dataForUpdate = JSON.parse(
            JSON.stringify(companyStore.companyUpdatePayload)
        );

        if (0 === Object.keys(dataForUpdate).length) {
            dataForUpdate = dataForReset;
        }

        if (!dataForUpdate.resources) {
            dataForUpdate.resources = [
                {
                    image: "",
                    title: "",
                    description: "",
                    url: ""
                }
            ];
            // 	"image": "",
            //   "description": "",
            //   "title": "",
            //   "url": ""
        }
        if (!dataForUpdate.testimonials) {
            dataForUpdate.testimonials = [];
            //  "image": "",
            // "description": "",
            // "name": "",
            // "company": "",
            // "title": ""
        }
        this.valueForReset = dataForReset;
        this.updatePayload = dataForUpdate;
    }

    resetData() {
        companyStore.setCompanyUpdatePayload({});
        this.initData();
        this.updatePayload = this.valueForReset;
    }
    resetSubmitFlags() {
        this.isLoading = false;
        this.submitSucess = false;
        this.submitError = false;
    }
    setUpdatePayload() {
        const payload = this.updatePayload;
        companyStore.setCompanyUpdatePayload(payload);
    }
    handleCancel() {
        this.resetData();
        this.$emit("cancel");
    }
    handleSubmit() {
        this.setUpdatePayload();
        this.$emit("submit");
    }
    handleUpdateStarted() {
        this.isLoading = true;
    }
    handleUpdateSuccess() {
        this.submitSucess = true;
        this.resetData();
    }
    handleUpdateError() {
        this.submitError = true;
    }
    handleUpdateDone() {
        this.isLoading = false;
    }

    addSocialMediaInput() {
        console.log("TODO");
    }

    addMoreResources() {
        const obj = {
            image: "",
            title: "",
            description: "",
            url: ""
        };
        this.updatePayload.resources.push(obj);
    }
}
